import {
  formatReportProgressMessage,
} from '../utils/dashboardReportProgress'

export default function DashboardExportProgressBanner({ progress }) {
  if (!progress) return null

  const pct = Math.max(0, Math.min(100, Math.round(progress.percent ?? 0)))
  const title =
    progress.phase === 'capture' ? 'Capturing dashboard charts' : 'Building your report'
  const detail = formatReportProgressMessage(progress)
  const chartPhases = progress.phase === 'capture' || progress.phase === 'data'
  const pendingCount = chartPhases
    ? progress.pendingCharts?.length ??
      (progress.chartsRemaining != null
        ? progress.chartsRemaining
        : progress.total > 0
          ? Math.max(
              0,
              progress.total - (progress.chartsAdded ?? progress.current ?? 0),
            )
          : 0)
    : 0
  const pendingLabel =
    chartPhases && pendingCount > 0
      ? `${pendingCount} chart${pendingCount === 1 ? '' : 's'} pending`
      : ''
  const completedList =
    progress.completedCharts?.length > 0
      ? progress.completedCharts.slice(-3).join(', ')
      : ''

  return (
    <div className="dashboardExportProgressBanner" role="status" aria-live="polite">
      <div className="dashboardExportProgressBrand">SoHo Social</div>
      <div className="dashboardExportProgressTitle">{title}</div>
      <p className="dashboardExportProgressLine">{detail}</p>
      {pendingLabel && (
        <p className="dashboardExportProgressLine dashboardExportProgressLine--pending">
          {pendingLabel}
        </p>
      )}
      {completedList && (
        <p className="dashboardExportProgressLine dashboardExportProgressLine--completed">
          Added: {completedList}
        </p>
      )}
      <div className="dashboardExportProgressBarTrack">
        <div
          className="dashboardExportProgressBarFill"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="dashboardExportProgressPct">{pct}% complete</div>
    </div>
  )
}
